var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00019 15.1999C5.00019 16.0836 5.71654 16.7999 6.60019 16.7999C7.48385 16.7999 8.20019 16.0836 8.20019 15.1999L8.2002 6.26269L10.2688 8.33132C10.8937 8.95616 11.9067 8.95616 12.5316 8.33132C13.1564 7.70648 13.1564 6.69342 12.5316 6.06858L7.73157 1.26858C7.43151 0.968517 7.02454 0.799947 6.6002 0.799947C6.17585 0.799947 5.76888 0.968517 5.46882 1.26858L0.668824 6.06858C0.0439849 6.69341 0.0439848 7.70648 0.668824 8.33132C1.29366 8.95616 2.30673 8.95616 2.93157 8.33132L5.00019 6.26269L5.00019 15.1999Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 8.79995C21.0002 7.91629 20.2839 7.19995 19.4002 7.19995C18.5165 7.19995 17.8002 7.91629 17.8002 8.79995L17.8002 17.7372L15.7316 15.6686C15.1067 15.0437 14.0937 15.0437 13.4688 15.6686C12.844 16.2934 12.844 17.3065 13.4688 17.9313L18.2688 22.7313C18.5689 23.0314 18.9758 23.2 19.4002 23.2C19.8245 23.2 20.2315 23.0314 20.5316 22.7313L25.3316 17.9313C25.9564 17.3065 25.9564 16.2934 25.3316 15.6686C24.7067 15.0437 23.6937 15.0437 23.0688 15.6686L21.0002 17.7372L21.0002 8.79995Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.00025,
    y1: 0.999758,
    x2: 25.0002,
    y2: 18.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E63A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 6.00025,
    y1: 0.999758,
    x2: 25.0002,
    y2: 18.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E63A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.1744d90e.svg";
export { ForwardRef as ReactComponent };